export { FolderItem as default };

/**
* Folder Entity
*
* Defines folder data struture
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FolderItem {
  /**
   * Folder Id
   *
   * @public
   *
   * @type {String|null}
   *
   * @since 7.0.0
   */
  id = null;

  /**
   * Defines parent folder id
   *
   * @public
   *
   * @type {String|null}
   *
   * @since 7.0.0
   */
  parent = null;

  /**
   * Folder name
   *
   * @public
   *
   * @type {String|null}
   *
   * @since 7.0.0
   */
  name = null;

  /**
   * Folder Sub Level
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  level  = 1;

  /**
   * Folder Unread count
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  unread = 0;

  /**
   * Defines if it's a main folder
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  main = false;

  /**
   * Defines if folder has childs
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  childs = false;

  /**
   * Defines the number of unread messages of all childs
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  childs_unread = 0;

  /**
   * Defines folder full path
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  path = '/';

  /**
   * Defines folder imap path
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  imap = '/';

  /**
   * Folders icon
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  icon;

  /**
   * Define folder is error
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  error;
}